import { PackingList } from '../models/packing-list.model';

export interface PackingListsState {
  lists: PackingList[];
  loading: boolean;
  saving: boolean;
  loadError: string | null;
  addItemError: string | null;
}

export const initialState: PackingListsState = {
  lists: [],
  loading: false,
  saving: false,
  loadError: null,
  addItemError: null,
};
